const removeResultList = () => {
  $('#result-list').removeClass('loaded')

  $("#result-list").bind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", () => {
    $('#result-list').remove()
  })
}

export default removeResultList



// WEBPACK FOOTER //
// ./app/result-list/removeResultList.js